import BorrowAmount from './BorrowAmount';

export * from './BorrowAmount';

export default BorrowAmount;
